import script from "./ContractApprovalDownloadPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractApprovalDownloadPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./ContractApprovalDownloadPopUp.vue?vue&type=style&index=0&id=180a3d6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180a3d6d"]])

export default __exports__